import { render } from "./CIS-Icon-Group.vue?vue&type=template&id=57da5ba6&scoped=true"
import script from "./CIS-Icon-Group.vue?vue&type=script&lang=js"
export * from "./CIS-Icon-Group.vue?vue&type=script&lang=js"

import "./CIS-Icon-Group.vue?vue&type=style&index=0&id=57da5ba6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57da5ba6"]])

export default __exports__